const es = {
  app: {
    title: 'BFPE Token DApp',
    subtitle: 'Aplicación Web3 para interactuar con el token BFPE en Hyperledger Besu',
  },
  nav: {
    tokens: 'Tokens',
    nfts: 'NFTs',
    tutorial: 'Tutorial',
    docs: 'Documentación',
  },
  lang: {
    es: 'Castellano',
    eu: 'Euskera',
    en: 'English',
  },
  wallet: {
    connect: 'Conectar Wallet',
    connecting: 'Conectando...',
    connected: 'Wallet conectada',
    chainId: 'Chain ID',
    address: 'Dirección',
    balance: 'Balance',
    copy: 'Copiar dirección completa',
    copied: '¡Copiado!',
    switchNetwork: 'Cambiar a red Besu (ID: {chainId})',
    disconnect: 'Desconectar',
    // WalletConnect component
    title: 'Conexión de Wallet',
    connectedBadge: 'Conectado',
    switchBtn: 'Cambiar a red Besu (Chain ID: {chainId})',
    description: 'Conecta tu wallet para interactuar con el contrato BFPE Token en Hyperledger Besu.',
    note: 'Nota:',
    noteText: 'Asegúrate de tener MetaMask instalado y configurado para conectarte a tu red Hyperledger Besu.',
    addressLabel: 'Dirección de Cuenta',
    chainIdLabel: 'Chain ID',
    notDetected: 'No detectado',
    disconnectBtn: 'Desconectar Wallet',
  },
  tokenInfo: {
    title: 'Información del Token',
    refresh: 'Actualizar',
    name: 'Nombre',
    symbol: 'Símbolo',
    totalSupply: 'Total Supply',
    yourBalance: 'Tu Balance',
    status: 'Estado',
    paused: 'Pausado',
    active: 'Activo',
    contractAddress: 'Dirección del Contrato',
    configRequired: 'Configuración requerida:',
    configMessage: 'Por favor configura la dirección del contrato en el archivo .env',
  },
  transfer: {
    title: 'Transferir Tokens',
    noWallet: 'Conecta tu wallet para transferir tokens',
    recipientLabel: 'Dirección del Destinatario',
    recipientPlaceholder: '0x...',
    amountLabel: 'Cantidad (BFPE)',
    amountPlaceholder: '0.0',
    errNoWallet: 'Por favor conecta tu wallet primero',
    errInvalidAddress: 'Dirección de destinatario inválida',
    errInvalidAmount: 'Cantidad inválida',
    successTitle: '¡Transferencia exitosa!',
    successTx: 'TX: {hash}',
    toastLoading: 'Transfiriendo tokens...',
    toastSuccess: '¡{amount} BFPE transferidos exitosamente!',
    toastError: 'Error al transferir tokens',
    processing: 'Procesando...',
    submit: 'Transferir Tokens',
  },
  faucet: {
    title: 'Token Faucet',
    noWallet: 'Conecta tu wallet para solicitar tokens gratuitos',
    amountLabel: 'Cantidad por Solicitud',
    cooldownLabel: 'Tiempo de Espera',
    hours: '{n} horas',
    nextRequest: 'Próxima solicitud disponible en:',
    availableNow: '¡Puedes solicitar tokens ahora!',
    errNoWallet: 'Por favor conecta tu wallet primero',
    errCooldown: 'Debes esperar antes de solicitar más tokens',
    successTitle: '¡Tokens recibidos exitosamente!',
    successTx: 'TX: {hash}',
    toastLoading: 'Solicitando tokens del faucet...',
    toastSuccess: '¡Tokens recibidos exitosamente!',
    toastError: 'Error al solicitar tokens del faucet',
    processing: 'Procesando...',
    submit: 'Solicitar {amount} BFPE',
    infoPrefix: 'ℹ️ Información:',
    infoText: 'Puedes solicitar tokens gratuitos cada {hours} horas. Los tokens se transferirán automáticamente a tu wallet después de confirmar la transacción.',
    contractLabel: 'Contrato del Token BFPE',
    copyAddress: 'Copiar dirección',
    importMetaMask: 'Importar BFPE en MetaMask',
  },
  mintBurn: {
    title: 'Mint & Burn',
    noWallet: 'Conecta tu wallet para crear o quemar tokens',
    mintTitle: 'Crear Tokens (Mint)',
    burnTitle: 'Quemar Tokens (Burn)',
    recipientLabel: 'Dirección del Destinatario',
    recipientPlaceholder: '0x...',
    amountLabel: 'Cantidad (BFPE)',
    burnAmountLabel: 'Cantidad a Quemar (BFPE)',
    amountPlaceholder: '0.0',
    errNoWallet: 'Por favor conecta tu wallet primero',
    errInvalidAddress: 'Dirección inválida',
    errInvalidAmount: 'Cantidad inválida',
    mintSuccessTitle: '¡Mint exitoso!',
    burnSuccessTitle: '¡Burn exitoso!',
    successTx: 'TX: {hash}',
    mintToastLoading: 'Creando tokens (mint)...',
    mintToastSuccess: '¡{amount} BFPE creados exitosamente!',
    mintToastError: 'Error al crear tokens. Verifica que seas el owner.',
    burnToastLoading: 'Quemando tokens (burn)...',
    burnToastSuccess: '¡{amount} BFPE quemados exitosamente!',
    burnToastError: 'Error al quemar tokens',
    processing: 'Procesando...',
    mintSubmit: 'Crear Tokens',
    burnSubmit: 'Quemar Tokens',
  },
  admin: {
    title: 'Panel de Administración',
    noWallet: 'Conecta tu wallet para acceder al panel de administración',
    notOwner: 'Solo el owner del contrato puede acceder a estas funciones.',
    isOwner: '✅ Eres el owner del contrato',
    transfersTitle: 'Control de Transferencias',
    currentStatus: 'Estado actual:',
    paused: 'Pausado',
    active: 'Activo',
    successTitle: '¡Operación exitosa!',
    successTx: 'TX: {hash}',
    resumeToastLoading: 'Reanudando transferencias...',
    resumeToastSuccess: '¡Transferencias reanudadas!',
    pauseToastLoading: 'Pausando transferencias...',
    pauseToastSuccess: '¡Transferencias pausadas!',
    pauseToastError: 'Error al cambiar estado de pausa',
    processing: 'Procesando...',
    resumeBtn: 'Reanudar Transferencias',
    pauseBtn: 'Pausar Transferencias',
    ownershipTitle: 'Transferir Ownership',
    newOwnerLabel: 'Nueva Dirección del Owner',
    newOwnerPlaceholder: '0x...',
    errInvalidAddress: 'Dirección inválida',
    ownershipSuccessTitle: '¡Ownership transferido!',
    ownershipToastLoading: 'Transfiriendo ownership...',
    ownershipToastSuccess: '¡Ownership transferido exitosamente!',
    ownershipToastError: 'Error al transferir ownership',
    warningLabel: '⚠️ Advertencia:',
    warningText: 'Esta acción es irreversible. Perderás todos los privilegios de administrador.',
    ownershipSubmit: 'Transferir Ownership',
  },
  events: {
    title: 'Eventos On-Chain',
    pause: 'Pausar',
    resume: 'Reanudar',
    clear: 'Limpiar',
    waiting: 'Esperando eventos... Las transacciones aparecerán aquí.',
    unknownEvent: '{event} en bloque {block}',
    mintMsg: 'Mint {value} BFPE → {to}',
    burnMsg: 'Burn {value} BFPE ← {from}',
    transferMsg: 'Transfer {value} BFPE: {from} → {to}',
    faucetMsg: 'Faucet {amount} BFPE → {to}',
  },
  tutorial: {
    title: 'Tutorial Interactivo',
    subtitle: 'Aprende a usar la BFPE DApp paso a paso',
    progress: 'Progreso del Tutorial',
    completed: '{done}/{total} completados',
    prev: 'Anterior',
    next: 'Siguiente',
    markDone: 'Completado ✓',
    practice: 'Ir a practicar →',
    tip: '💡 Tip:',
    steps: [
      {
        title: '1. Conecta tu Wallet',
        tab: 'tokens',
        icon: '🦊',
        content: 'Para interactuar con la blockchain, necesitas una wallet. MetaMask es la más popular. Instálala como extensión del navegador y conéctala pulsando "Conectar Wallet" en la esquina superior derecha.',
        tip: 'MetaMask debe estar configurada para la red BFPE Mainnet: RPC URL https://bfpe-mainnet.blockchain.tkn.eus, Chain ID 1337, Símbolo: BFPE. La propia app te ofrecerá cambiar de red automáticamente si detecta que estás en otra.',
      },
      {
        title: '2. Solicita Tokens del Faucet',
        tab: 'tokens',
        icon: '💧',
        content: 'Un faucet es un mecanismo que distribuye tokens gratuitos para pruebas. Ve a la sección Tokens y pulsa "Solicitar" para recibir tokens BFPE. Hay un tiempo de espera (cooldown) entre solicitudes para evitar abusos.',
        tip: 'En redes reales, los faucets solo existen en testnets para que los desarrolladores puedan probar sus contratos sin coste. En BFPE Mainnet el faucet es educativo y está limitado por el owner del contrato.',
      },
      {
        title: '3. Transfiere Tokens',
        tab: 'tokens',
        icon: '📤',
        content: 'Envía tokens BFPE a otra dirección Ethereum. Introduce la dirección del destinatario (formato 0x...) y la cantidad. La transacción se registrará en la blockchain de forma permanente e inmutable.',
        tip: 'Cada transferencia genera un evento "Transfer" en el contrato ERC20. Puedes ver el historial completo de transacciones en el explorador de bloques: esploratzaile.blockchain.tkn.eus',
      },
      {
        title: '4. Mint & Burn de Tokens',
        tab: 'tokens',
        icon: '🔥',
        content: 'El owner del contrato puede crear (mint) nuevos tokens BFPE e incrementar el suministro total. Cualquier usuario puede quemar (burn) sus propios tokens, destruyéndolos permanentemente y reduciendo el suministro.',
        tip: 'Mint aumenta el totalSupply y burn lo reduce. Este mecanismo es la base de la política monetaria de un token. Solo el owner (0x9e6d0B27762BfCD7d8913C9474583d715672ee87) puede mintear nuevos tokens.',
      },
      {
        title: '5. Panel de Administración',
        tab: 'tokens',
        icon: '🛡️',
        content: 'Si conectas la wallet del owner del contrato, verás el Panel de Admin. Desde ahí puedes pausar todas las transferencias del token, configurar el cooldown y cantidad del faucet, o transferir la propiedad a otra dirección.',
        tip: 'El patrón Ownable de OpenZeppelin garantiza que solo una dirección tenga privilegios de administrador. Cuando el contrato está pausado, ninguna transferencia puede ejecutarse — ni siquiera el owner puede transferir tokens.',
      },
      {
        title: '6. Mina un NFT',
        tab: 'nfts',
        icon: '🎨',
        content: 'Los NFTs (Non-Fungible Tokens) son tokens únicos e irrepetibles. Ve a la sección NFTs, introduce una URI de metadatos (enlace a un JSON o imagen) y pulsa "Minar NFT". El precio de minado es 0.5 BFPE.',
        tip: 'MetaMask pedirá dos transacciones: primero aprobar el gasto de 0.5 BFPE al contrato NFT (approve ERC20), y luego la operación de minado. Los metadatos suelen ser un JSON en IPFS con campos: name, description e image.',
      },
      {
        title: '7. Gestiona tu Colección',
        tab: 'nfts',
        icon: '📦',
        content: 'En "Mis NFTs" verás todos los NFTs que posees con su Token ID único. Puedes importarlos a MetaMask con el botón "Importar a MetaMask" para verlos en tu wallet, o listarlos en el marketplace indicando un precio en BFPE.',
        tip: 'Para listar un NFT son necesarias dos transacciones (Paso 1/2 y Paso 2/2): primero autorizas al contrato Marketplace a transferir tu NFT en tu nombre (approve ERC721), y luego registras el listing con el precio deseado.',
      },
      {
        title: '8. Marketplace de NFTs',
        tab: 'nfts',
        icon: '🏪',
        content: 'El marketplace descentralizado permite comprar y vender NFTs entre usuarios. Los vendedores listan sus NFTs con un precio en BFPE. Para comprar, el comprador aprueba el gasto de BFPE y luego confirma la compra.',
        tip: 'El pago se realiza en tokens BFPE, no en ETH nativo (la red Besu no tiene ETH nativo). La plataforma cobra un fee del 2.5% por cada venta que va al owner. Contrato Marketplace: 0x6b3afb8A91fB704ACb187A96057fc1B28Ae24B0B',
      },
      {
        title: '9. Panel de Eventos',
        tab: 'tokens',
        icon: '📡',
        content: 'El panel de eventos muestra en tiempo real todas las operaciones que ocurren en la blockchain: transfers, mints, burns, solicitudes de faucet... Se actualiza automáticamente con cada nuevo bloque.',
        tip: 'Los eventos Solidity son la forma principal de indexar lo que ocurre en una blockchain. Los exploradores de bloques como esploratzaile.blockchain.tkn.eus los usan para construir el historial de transacciones.',
      },
      {
        title: '10. Explorador de Bloques',
        tab: 'tokens',
        icon: '🔍',
        content: 'La red BFPE tiene su propio explorador donde puedes ver todas las transacciones, contratos desplegados, tokens y eventos. Accede en esploratzaile.blockchain.tkn.eus para inspeccionar cualquier operación.',
        tip: 'Contratos activos en la red: Token BFPE (0xf556f877Eb8E66393e6F044B2196490A267967bD), NFT BFPENFT (0x0230fF20f9A10359e97683732694a947B1e9EfF5), Marketplace (0x6b3afb8A91fB704ACb187A96057fc1B28Ae24B0B).',
      },
    ],
  },
  mintNFT: {
    title: 'Minar NFT',
    noWallet: 'Conecta tu wallet para minar NFTs',
    mintPriceLabel: 'Precio de minado:',
    contractLabel: 'Contrato NFT:',
    dragDrop: 'Arrastra un archivo aquí o haz clic para seleccionar',
    formats: 'Formatos: JPG, PNG, GIF, WEBP, PDF · Imágenes hasta 20 MB (se comprimen a 5 MB) · PDFs hasta 5 MB',
    fileAriaLabel: 'Seleccionar archivo para NFT',
    previewAlt: 'Previsualización',
    removeAriaLabel: 'Eliminar archivo seleccionado',
    compressionWarning: 'La imagen supera 5 MB y será comprimida automáticamente al subirse.',
    uploadSuccess: 'Archivo subido correctamente',
    uploadError: 'Error al subir el archivo',
    errFormat: 'Formato no permitido. Formatos admitidos: JPG, PNG, GIF, WEBP, PDF',
    errPdfSize: 'Los archivos PDF no pueden superar 5 MB',
    errImgSize: 'Las imágenes no pueden superar 20 MB',
    errNoWallet: 'Por favor conecta tu wallet primero',
    errNoFile: 'Por favor sube un archivo primero',
    approveLoading: 'Aprobando gasto de BFPE...',
    approveSuccess: 'Aprobación confirmada',
    mintLoading: 'Minando NFT...',
    mintSuccess: '¡NFT minado exitosamente!',
    mintError: 'Error al minar NFT',
    uploadingBtn: 'Subiendo...',
    uploadingCompressingBtn: 'Subiendo y comprimiendo...',
    uploadBtn: 'Subir archivo',
    mintingBtn: 'Minteando...',
    mintBtn: 'Minar NFT · {price} BFPE',
    mintSuccessTitle: '¡NFT minado exitosamente!',
    viewExplorer: 'Ver en el explorador',
    nameLabel: 'Nombre del NFT',
    namePlaceholder: 'Ej: Mi primera obra de arte',
    descLabel: 'Descripción (opcional)',
    descPlaceholder: 'Describe tu NFT...',
    errNoName: 'El nombre del NFT es obligatorio',
  },
  myNFTs: {
    title: 'Mis NFTs',
    noWallet: 'Conecta tu wallet para ver tus NFTs',
    empty: 'No tienes NFTs aún',
    emptySubtext: 'Mina tu primer NFT para comenzar',
    nftTitle: 'NFT #{id}',
    tokenId: 'Token ID: {id}',
    creator: 'Creator: {address}',
    listed: 'Listado',
    importBtn: 'Importar a MetaMask',
    tokenUriLabel: 'Token URI:',
    pricePlaceholder: 'Precio en BFPE',
    errInvalidPrice: 'Por favor ingresa un precio válido',
    errNoMetaMask: 'MetaMask no está disponible',
    errImport: 'No se pudo importar el NFT: {message}',
    step1Loading: 'Paso 1/2 — Autorizando al Marketplace para transferir el NFT...',
    step1Success: 'Paso 1/2 completado ✓',
    step2Loading: 'Paso 2/2 — Publicando NFT en el Marketplace...',
    step2Success: '¡NFT publicado en el Marketplace!',
    listingBtn: 'Listando...',
    listBtn: 'Listar en Marketplace',
  },
  marketplace: {
    title: 'NFT Marketplace',
    noWallet: 'Conecta tu wallet para ver el marketplace',
    empty: 'No hay NFTs listados',
    emptySubtext: 'Sé el primero en listar un NFT',
    nftTitle: 'NFT #{id}',
    seller: 'Seller: {address}',
    creator: 'Creator: {address}',
    tokenUri: 'Token URI:',
    priceLabel: 'Precio',
    yourNFT: 'Tu NFT',
    approveLoading: 'Aprobando gasto de BFPE...',
    approveSuccess: 'Aprobación confirmada',
    buyLoading: 'Comprando NFT...',
    buySuccess: '¡NFT comprado exitosamente!',
    buyingBtn: 'Comprando...',
    buyBtn: 'Comprar NFT',
  },
  nftPage: {
    configTitle: 'Configuración Requerida',
    configMessage: 'Por favor configura las direcciones de los contratos NFT en el archivo .env:',
    configNote: 'Ejecuta',
    configNote2: 'para desplegar los contratos.',
    title: 'NFT Collection & Marketplace',
    subtitle: 'Mina, colecciona y comercia NFTs',
  },
  docs: {
    title: 'Documentación',
    subtitle: 'Conceptos clave de Blockchain, Smart Contracts y Web3',
    categories: [
      {
        category: 'Conceptos Básicos',
        items: [
          {
            title: '¿Qué es Blockchain?',
            content: 'Una blockchain es un libro de contabilidad digital distribuido que registra transacciones en una red de ordenadores. Cada bloque contiene un hash del bloque anterior, creando una cadena inmutable. No hay un servidor central; todos los nodos mantienen una copia idéntica.',
          },
          {
            title: '¿Qué es Hyperledger Besu?',
            content: 'Hyperledger Besu es un cliente Ethereum de código abierto desarrollado bajo la Fundación Linux. Es compatible con EVM (Ethereum Virtual Machine) y soporta tanto redes públicas como privadas/permisionadas. Ideal para entornos empresariales y educativos.',
          },
          {
            title: '¿Qué es una Wallet?',
            content: 'Una wallet (como MetaMask) almacena tus claves privadas y te permite firmar transacciones. Tu dirección pública (0x...) es como tu número de cuenta, y tu clave privada es como tu contraseña. NUNCA compartas tu clave privada.',
          },
          {
            title: '¿Qué es Gas?',
            content: 'Gas es la unidad que mide el trabajo computacional necesario para ejecutar operaciones en la EVM. Cada operación tiene un coste en gas. En nuestra red Besu de desarrollo, el gas price es 0, así que las transacciones son gratis.',
          },
        ],
      },
      {
        category: 'Tokens & Estándares',
        items: [
          {
            title: 'ERC-20 (Token Fungible)',
            content: 'ERC-20 es el estándar para tokens fungibles (intercambiables). Define funciones como transfer(), approve(), transferFrom(), balanceOf(), totalSupply(). Nuestro BFPE Token implementa este estándar usando OpenZeppelin, con funcionalidades adicionales como mint, burn, pausa y faucet.',
          },
          {
            title: 'ERC-721 (NFT)',
            content: 'ERC-721 es el estándar para tokens no fungibles (únicos). Cada token tiene un ID único y puede tener metadatos asociados (imagen, nombre, etc.). Funciones clave: ownerOf(), safeTransferFrom(), approve(), tokenURI(). Nuestro BFPENFT implementa ERC721 + ERC721URIStorage + ERC721Enumerable.',
          },
          {
            title: '¿Qué es OpenZeppelin?',
            content: 'OpenZeppelin es una biblioteca de smart contracts auditados y probados. Proporciona implementaciones estándar de ERC-20, ERC-721, control de acceso (Ownable), seguridad (ReentrancyGuard, Pausable) y más. Usar OpenZeppelin en lugar de implementaciones personalizadas reduce enormemente el riesgo de vulnerabilidades.',
          },
        ],
      },
      {
        category: 'Smart Contracts',
        items: [
          {
            title: '¿Qué es un Smart Contract?',
            content: 'Un smart contract es un programa que se ejecuta en la blockchain. Una vez desplegado, su código es inmutable. Los usuarios interactúan con él enviando transacciones. El contrato tiene un estado (variables) que se almacena permanentemente en la blockchain.',
          },
          {
            title: '¿Qué es una ABI?',
            content: 'La ABI (Application Binary Interface) es la interfaz que define cómo interactuar con un smart contract. Es un JSON que describe las funciones, sus parámetros y tipos de retorno. El frontend necesita la ABI para saber qué funciones puede llamar y cómo codificar/decodificar los datos.',
          },
          {
            title: 'Eventos (Events)',
            content: 'Los eventos son logs que los smart contracts emiten durante su ejecución. Son baratos de almacenar y permiten a las aplicaciones "escuchar" lo que ocurre en la blockchain. Por ejemplo, cada Transfer emite un evento con from, to y value.',
          },
          {
            title: 'Modifiers',
            content: 'Los modificadores (modifiers) son decoradores que añaden condiciones a las funciones. Por ejemplo, onlyOwner requiere que solo el propietario del contrato pueda ejecutar la función. whenNotPaused previene la ejecución cuando el contrato está pausado.',
          },
        ],
      },
      {
        category: 'Marketplace & DeFi',
        items: [
          {
            title: '¿Cómo funciona el Marketplace?',
            content: '1) El vendedor aprueba al marketplace para transferir su NFT (approve). 2) Llama a listNFT() con el precio. 3) El comprador llama a buyNFT() enviando ETH. 4) El contrato transfiere el NFT al comprador, el pago al vendedor (menos el fee), y el fee al owner del marketplace.',
          },
          {
            title: 'Patrón Approve + Transfer',
            content: 'En Ethereum, un contrato no puede "tomar" tokens directamente. El owner debe primero aprobar (approve) al contrato para que pueda mover sus tokens. Este patrón de dos pasos es fundamental tanto en ERC-20 como en ERC-721.',
          },
          {
            title: 'ReentrancyGuard',
            content: 'La reentrancia es un ataque donde un contrato malicioso vuelve a llamar a una función antes de que termine la primera ejecución (el famoso hackeo de "The DAO"). ReentrancyGuard de OpenZeppelin previene esto bloqueando llamadas recursivas.',
          },
        ],
      },
      {
        category: 'Herramientas de Desarrollo',
        items: [
          {
            title: 'Hardhat',
            content: 'Hardhat es un entorno de desarrollo para Ethereum. Permite compilar contratos Solidity, ejecutar tests, desplegar contratos y debuggar. Incluye una red local para desarrollo. En este proyecto lo usamos para compilar y desplegar en Besu.',
          },
          {
            title: 'Web3.js',
            content: 'Web3.js es una biblioteca JavaScript que permite interactuar con nodos Ethereum. Proporciona métodos para enviar transacciones, llamar funciones de contratos, consultar balances, escuchar eventos, etc. Es el puente entre el frontend y la blockchain.',
          },
          {
            title: 'MetaMask',
            content: 'MetaMask es una extensión de navegador que actúa como wallet y proveedor Web3. Inyecta el objeto window.ethereum que permite a las DApps solicitar acceso a las cuentas del usuario y firmar transacciones.',
          },
          {
            title: 'Docker',
            content: 'Docker permite ejecutar toda la infraestructura (Besu, deployer, frontend) en contenedores aislados. Esto facilita la reproducibilidad: cualquier alumno puede levantar el entorno completo con un solo comando.',
          },
        ],
      },
    ],
  },
};

export default es;
